import {
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { BaseComponent } from '../../../shared/base-classes/base.component';
import {
  DateUtil,
  DefaultOptionCategoriesIncidentEnum,
  DispositionCreateDto,
  DispositionUpdateDto,
  HeroDispositionUpdateDto,
  IDisplayData,
  IncidentResponseDto,
  IncidentStatusEnum,
  PrivilegeEnum,
  ReferralDetailResponseDto,
  ReferralReviewUpdateDto,
  ReferralUpdateDto, SchoolDetailResponseDto,
  StudentDetailResponseDto
} from '@whetstoneeducation/hero-common';
import { AppToastManagerService } from '../../../shared/services/toast-manager.service';
import { AppPageHeaderService } from '../../../shared/page-header/page-header.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AppIncidentService } from '../incident.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IReferralEditResolverData } from './referral-edit-resolver-data.interface';
import { map, Observable, startWith, Subject, takeUntil } from 'rxjs';
import { HeaderButtonAction } from '../../../shared/page-header/header-button';
import {
  dtoToFormGroup,
  formCanSave,
  validateAndGetValue
} from '../../../shared/validation/validation.util';
import { AppPrivilegesService } from '../../auth/privileges.service';
import { AppBehaviorCodeEntryService } from '../../behavior-code-entry/behavior-code-entry.service';
import { ReferralRejectModalComponent } from './referral-reject-modal/referral-reject-modal/referral-reject-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { AppSchoolsServices } from '../../schools/schools.service';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-referral-edit',
  templateUrl: './referral-edit.component.html',
  styleUrls: ['./referral-edit.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReferralEditComponent
  extends BaseComponent
  implements OnInit, OnDestroy {
  public referralId: number;
  public referral: ReferralDetailResponseDto;
  public student: StudentDetailResponseDto;
  public incident: IncidentResponseDto;
  public school: SchoolDetailResponseDto;
  public incidentPlace: string;
  public referralForm: FormGroup;
  public referralReviewForm: FormGroup;
  public heroDispositionForm: FormGroup;
  public localDispositionForms: {
    [key: number]: FormGroup;
  };
  public stateDispositionForms: {
    [key: number]: FormGroup;
  };
  public localDispositionsMultiselect: FormControl = new FormControl([]);
  public stateDispositionsMultiselect: FormControl = new FormControl([]);

  public isReviewing: boolean;
  public studentWithSpecialNeedsOptions: IDisplayData[] = [];
  public bullyingOptions: IDisplayData[] = [];
  public motivationOptions: IDisplayData[] = [];
  public othersInvolvedOptions: IDisplayData[] = [];
  public basisOfBullyingOptions: IDisplayData[] = [];
  public previousActionTakenOptions: IDisplayData[] = [];
  public incidentContextOptions: IDisplayData[] = [];
  public severityLevelOptions: IDisplayData[] = [];
  public dueProcessOptions: IDisplayData[] = [];
  public localDispositionOptions: IDisplayData[] = [];
  private localDispositionSelectedOptions: number[] = []
  public stateDispositionOptions: IDisplayData[] = [];
  private stateDispositionSelectedOptions: number[] = []
  public durationOptions: IDisplayData[] = [];
  public behaviorCodeOptions: IDisplayData[] = [];
  public behaviorCodeReactionOptions: IDisplayData[] = [];
  private destroy$ = new Subject<void>();
  public isPrintable: boolean = false;
  public incidentTypeOptions: IDisplayData[] = [];
  public incidentTypeObject: IDisplayData;
  public filteredSpecialNeeds: Observable<IDisplayData[]>;
  public filteredMotivations: Observable<IDisplayData[]>;
  public filteredOthersInvolved: Observable<IDisplayData[]>;
  public filteredBullying: Observable<IDisplayData[]>;
  public filteredBasisofBullying: Observable<IDisplayData[]>;
  public filteredPreviousActionTaken: Observable<IDisplayData[]>;
  public filteredContext: Observable<IDisplayData[]>;
  public filteredLevel: Observable<IDisplayData[]>;
  public filteredProcess: Observable<IDisplayData[]>;

  constructor(
    public incidentService: AppIncidentService,
    public schoolService: AppSchoolsServices,
    public route: ActivatedRoute,
    public router: Router,
    public pageHeaderService: AppPageHeaderService,
    public toastService: AppToastManagerService,
    public formBuilder: FormBuilder,
    public privilegesService: AppPrivilegesService,
    public behaviorCodeEntryService: AppBehaviorCodeEntryService,
    public dialog: MatDialog
  ) {
    super({ privilegesService });
  }

  async ngOnInit() {
    this.isPrintable =
      this.route.snapshot.queryParamMap.get('printable') === 'true';
    await this.loadData(this.route.snapshot.data.data);
    this.pageHeaderService.buttonAction$
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (action: HeaderButtonAction) => {
        switch (action) {
          case HeaderButtonAction.SAVE:
            await this.saveChanges();
            break;
          case HeaderButtonAction.SAVE_AND_SUBMIT:
            await this.saveChanges(true);
            break;
          case HeaderButtonAction.REJECT:
            this.openRejectReferralMesageModal({
              isReview: true,
              referralId: this.referral.id
            });
            break;
          case HeaderButtonAction.APPROVE:
            if (this.formsHaveChanges()) {
              this.toastService.error(
                'Please save changes before approving the referral'
              );
              return;
            }

            if (
              this.heroDispositionForm.controls.behaviorCodeId.value &&
              !this.heroDispositionForm.controls.behaviorCodeReactionId.value
            ) {
              this.toastService.error(
                'Please update a the Hero Disposition with a Behavior Code Reaction before approving the referral'
              );
              return;
            }

            await this.changeStatus(IncidentStatusEnum.FINALIZED);
            await this.router.navigate(['/incident/', this.incident.id]);
            break;
          case HeaderButtonAction.BACK:
            await this.router.navigate(['/incident/', this.incident.id]);
            break;
          case HeaderButtonAction.PRINT:
            // window.print();
            // this.toastService.info('Printing is not available at this time');
            const url = this.router.serializeUrl(
              this.router.createUrlTree(['/referral', this.referralId], {
                queryParams: { printable: 'true' }
              })
            );
            window.open(url, '_blank');
            break;
          default:
            break;
        }
      });

    if (this.isReviewing) {
      if (this.referral.status === IncidentStatusEnum.FINALIZED) {
        this.pageHeaderService.changeButtons([
          {
            name: '',
            icon: 'arrow-down-to-line',
            action: HeaderButtonAction.PRINT,
            style: 'cancel-button'
          },
          {
            name: 'Back',
            action: HeaderButtonAction.BACK,
            style: 'cancel-button'
          },
          {
            name: 'Save',
            action: HeaderButtonAction.SAVE,
            style: 'success-button'
          }
        ]);
      } else {
        this.pageHeaderService.changeButtons([
          {
            name: 'Back',
            action: HeaderButtonAction.BACK,
            style: 'cancel-button'
          },
          {
            name: 'Save',
            action: HeaderButtonAction.SAVE,
            style: 'success-button'
          },
          {
            name: 'APPROVE',
            action: HeaderButtonAction.APPROVE,
            style: 'success-button'
          },
          {
            name: 'REJECT',
            action: HeaderButtonAction.REJECT,
            style: 'reject-button',
            privilege: PrivilegeEnum.MANAGE_INCIDENTS
          }
        ]);
      }
    }

    this.filteredSpecialNeeds = this.referralForm.get('studentWithSpecialNeedsId').valueChanges.pipe(
      startWith(''),
      map((value) => {
        const label = typeof value === 'string' ? value : value?.display;
        return this._filter(label, 'studentWithSpecialNeedsOptions');
      })
    );

    this.filteredMotivations = this.referralForm.get('motivationId').valueChanges.pipe(
      startWith(''),
      map((value) => {
        const label = typeof value === 'string' ? value : value?.display;
        return this._filter(label, 'motivationOptions');
      })
    );

    this.filteredOthersInvolved = this.referralForm.get('othersInvolvedId').valueChanges.pipe(
      startWith(''),
      map((value) => {
        const label = typeof value === 'string' ? value : value?.display;
        return this._filter(label, 'othersInvolvedOptions');
      })
    );

    this.filteredBullying = this.referralForm.get('bullyingId').valueChanges.pipe(
      startWith(''),
      map((value) => {
        const label = typeof value === 'string' ? value : value?.display;
        return this._filter(label, 'bullyingOptions');
      })
    );

    this.filteredBasisofBullying = this.referralForm.get('basisOfBullyingId').valueChanges.pipe(
      startWith(''),
      map((value) => {
        const label = typeof value === 'string' ? value : value?.display;
        return this._filter(label, 'basisOfBullyingOptions');
      })
    );

    this.filteredPreviousActionTaken = this.referralForm.get('previousActionTakenId').valueChanges.pipe(
      startWith(''),
      map((value) => {
        const label = typeof value === 'string' ? value : value?.display;
        return this._filter(label, 'previousActionTakenOptions');
      })
    );

    this.filteredContext = this.referralReviewForm?.get('incidentContextId').valueChanges.pipe(
      startWith(''),
      map((value) => {
        const label = typeof value === 'string' ? value : value?.display;
        return this._filter(label, 'incidentContextOptions');
      })
    );

    this.filteredLevel = this.referralReviewForm?.get('severityLevelId').valueChanges.pipe(
      startWith(''),
      map((value) => {
        const label = typeof value === 'string' ? value : value?.display;
        return this._filter(label, 'severityLevelOptions');
      })
    );

    this.filteredProcess = this.referralReviewForm?.get('dueProcessId').valueChanges.pipe(
      startWith(''),
      map((value) => {
        const label = typeof value === 'string' ? value : value?.display;
        return this._filter(label, 'dueProcessOptions');
      })
    );

  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private _filter(value: string, options: string): IDisplayData[] {
    if (!this[options]) {
      return [];
    } else if (!value) {
      return this[options];
    }

    const filterValue = value?.toLowerCase();

    return this[options].filter((option) => option.display.toLowerCase().includes(filterValue));
  }

  displaySelectedOption(options: string, optionSelected:number) {
    const groupSelected = this[options].find(item => item.value === optionSelected);
    return groupSelected?.display || '';
  }

  public openRejectReferralMesageModal(data: object) {
    const dialogRef = this.dialog.open(ReferralRejectModalComponent, {
      width: '648px',
      panelClass: 'default-dialog',
      data: data
    });

    dialogRef.afterClosed().subscribe(async (result: boolean) => {
      if (result) {
        await this.changeStatus(IncidentStatusEnum.REJECTED);
        await this.router.navigate(['/incident/', this.incident.id]);
      }
    });
  }

  public async loadData(data: IReferralEditResolverData) {
    this.isLoading = true;
    this.isReviewing =
      [
        IncidentStatusEnum.PENDING,
        IncidentStatusEnum.FINALIZED,
        IncidentStatusEnum.REJECTED
      ].includes(data.referral.status as IncidentStatusEnum) &&
      this.hasPrivilege(PrivilegeEnum.FINALIZE_INCIDENTS);
    this.incidentTypeOptions =
      data.referralOptions[DefaultOptionCategoriesIncidentEnum.INCIDENT_TYPES];
    this.basisOfBullyingOptions =
      data.referralOptions[
      DefaultOptionCategoriesIncidentEnum.BASIS_OF_BULLYING
      ];
    this.bullyingOptions =
      data.referralOptions[DefaultOptionCategoriesIncidentEnum.BULLYING];
    this.motivationOptions =
      data.referralOptions[DefaultOptionCategoriesIncidentEnum.MOTIVATION];
    this.othersInvolvedOptions =
      data.referralOptions[DefaultOptionCategoriesIncidentEnum.OTHERS_INVOLVED];
    this.previousActionTakenOptions =
      data.referralOptions[
      DefaultOptionCategoriesIncidentEnum.PREVIOUS_ACTION_TAKEN
      ];
    this.studentWithSpecialNeedsOptions =
      data.referralOptions[
      DefaultOptionCategoriesIncidentEnum.STUDENT_WITH_SPECIAL_NEEDS
      ];
    this.incidentContextOptions =
      data.referralOptions[
      DefaultOptionCategoriesIncidentEnum.INCIDENT_CONTEXT
      ];
    this.severityLevelOptions =
      data.referralOptions[DefaultOptionCategoriesIncidentEnum.SEVERITY_LEVEL];
    this.dueProcessOptions =
      data.referralOptions[DefaultOptionCategoriesIncidentEnum.DUE_PROCESS];
    this.localDispositionOptions =
      data.referralOptions[
      DefaultOptionCategoriesIncidentEnum.LOCAL_DISPOSITION
      ];
    this.stateDispositionOptions =
      data.referralOptions[
      DefaultOptionCategoriesIncidentEnum.STATE_DISPOSITION
      ];
    this.durationOptions =
      data.referralOptions[DefaultOptionCategoriesIncidentEnum.DURATION];

    this.behaviorCodeOptions = data.incidentBehaviorCodeOptions;
    this.behaviorCodeReactionOptions = data.behaviorCodeReactionOptions;

    this.loadReferral(data.referral);

    //get school and incident place to display
    this.school = await this.schoolService.getSchoolById(this.student.schoolId);
    let incidentPlaces = data.referralOptions[DefaultOptionCategoriesIncidentEnum.INCIDENT_PLACES];
    let objIncidentPlace = incidentPlaces?.find(ip => ip.value == this.incident.incidentPlaceId);
    this.incidentPlace = objIncidentPlace ? objIncidentPlace.display : 'No place';

    this.incidentTypeObject = this.incidentTypeOptions.find(
      (type) => type.value === this.incident.incidentTypeId
    );

    this.isLoading = false;
  }

  public loadReferral(referral: ReferralDetailResponseDto) {
    this.referralId = referral.id;
    this.referral = referral;
    this.student = referral.student;
    this.incident = referral.incident;
    const referralUpdateDto = new ReferralUpdateDto();
    referralUpdateDto.mapFields(referral);

    this.referralForm = dtoToFormGroup(referralUpdateDto, this.formBuilder, {
      mapId: false,
      updateOn: 'change',
    });
    if (this.isReviewing) {
      const referralReviewUpdateDto = new ReferralReviewUpdateDto();
      referralReviewUpdateDto.mapFields(referral);
      this.referralReviewForm = dtoToFormGroup(
        referralReviewUpdateDto,
        this.formBuilder,
        {
          mapId: false,
          updateOn: 'change'
        }
      );

      this.stateDispositionSelectedOptions = [];
      this.stateDispositionForms = {};

      for (const disposition of referral.stateDispositions) {
        const dto = new DispositionUpdateDto();
        dto.mapFields(disposition);
        this.stateDispositionForms[disposition.id] = dtoToFormGroup(
          dto,
          this.formBuilder,
          {
            mapId: false
          }
        );
        this.stateDispositionSelectedOptions = [...this.stateDispositionSelectedOptions, disposition.dispositionId];
      }

      this.stateDispositionsMultiselect.setValue(this.stateDispositionSelectedOptions);

      this.localDispositionSelectedOptions = [];
      this.localDispositionForms = {};
      for (const disposition of referral.localDispositions) {
        const dto = new DispositionUpdateDto();
        dto.mapFields(disposition);
        this.localDispositionForms[disposition.id] = dtoToFormGroup(
          dto,
          this.formBuilder,
          {
            mapId: false
          }
        );
        this.localDispositionSelectedOptions = [...this.localDispositionSelectedOptions, disposition.dispositionId];
      }

      this.localDispositionsMultiselect.setValue(this.localDispositionSelectedOptions);

      const heroDispositionUpdateDto = new HeroDispositionUpdateDto();
      heroDispositionUpdateDto.behaviorCodeId =
        referral.heroDisposition?.behaviorCode?.id;
      heroDispositionUpdateDto.behaviorCodeReactionId =
        referral.heroDisposition?.behaviorCodeReaction?.id;

      this.heroDispositionForm = dtoToFormGroup(
        heroDispositionUpdateDto,
        this.formBuilder,
        {
          mapId: false,
          updateOn: 'change',
        }
      );

      this.heroDispositionForm.controls.behaviorCodeId.valueChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(async (value) => {
          this.isLoading = true;
          const reactionOptions =
            await this.behaviorCodeEntryService.getReactionOptions(
              value,
              this.referral.student.id
            );
          this.behaviorCodeReactionOptions = reactionOptions.map((option) => ({
            value: option.id,
            display: option.name
          }));
          this.isLoading = false;
        });
    }
  }

  public async changeStatus(status: IncidentStatusEnum) {
    this.isLoading = true;
    try {
      await this.incidentService.updateReferral(
        this.referralId,
        new ReferralUpdateDto({ status, incidentId: this.incident.id })
      );
      this.toastService.success(
        `Referral ${status === IncidentStatusEnum.FINALIZED ? 'finalized' : 'rejected'
        }`
      );
      await this.router.navigate(['/incident/', this.incident.id]);
    } catch (e) {
      this.toastService.error('Error rejecting referral');
    } finally {
      this.isLoading = false;
    }
  }

  public async saveChanges(submit?: boolean) {
    this.isLoading = true;
    if (formCanSave(this.referralForm, this.toastService, false)) {
      const dto = await validateAndGetValue<ReferralUpdateDto>(
        this.referralForm,
        ReferralUpdateDto
      );
      try {
        if (submit) {
          dto.status = IncidentStatusEnum.PENDING;
          dto.incidentId = this.incident.id;
        }

        await this.incidentService.updateReferral(this.referralId, dto);
        this.toastService.success('Referral updated successfully');
      } catch (e) {
        this.toastService.error('Error updating referral');
      } finally {
        this.isLoading = false;
      }
    }
    if (this.isReviewing) {
      this.isLoading = true;
      if (formCanSave(this.referralReviewForm, this.toastService, false)) {
        const dto = await validateAndGetValue<ReferralReviewUpdateDto>(
          this.referralReviewForm,
          ReferralReviewUpdateDto
        );
        try {
          if (submit) {
            dto.status = IncidentStatusEnum.PENDING;
          }

          await this.incidentService.updateReferral(this.referralId, dto);
        } catch (e) {
          this.toastService.error('Error updating referral');
        }
      }
      const dispositionsToUpdate = [];

      for (const key of Object.keys(this.stateDispositionForms)) {
        const form = this.stateDispositionForms[key] as FormGroup;
        if (
          form.touched &&
          formCanSave(this.stateDispositionForms[key], this.toastService)
        ) {
          const dto = await validateAndGetValue<DispositionUpdateDto>(
            form,
            DispositionUpdateDto
          );
          dto.id = parseInt(key);
          dispositionsToUpdate.push(dto);
        }
      }

      for (const key of Object.keys(this.localDispositionForms)) {
        const form = this.localDispositionForms[key] as FormGroup;
        if (
          form.touched &&
          formCanSave(this.localDispositionForms[key], this.toastService)
        ) {
          const dto = await validateAndGetValue<DispositionUpdateDto>(
            form,
            DispositionUpdateDto
          );
          dto.id = parseInt(key);
          dispositionsToUpdate.push(dto);
        }
      }

      if (dispositionsToUpdate.length > 0) {
        try {
          await this.incidentService.updateDispositions(
            this.referralId,
            dispositionsToUpdate
          );
        } catch (e) {
          this.toastService.error('Error updating dispositions');
        }
      }

      if (
        formCanSave(this.heroDispositionForm, this.toastService, false) &&
        this.referral.status !== IncidentStatusEnum.FINALIZED
      ) {
        const dto = await validateAndGetValue<HeroDispositionUpdateDto>(
          this.heroDispositionForm,
          HeroDispositionUpdateDto
        );
        try {
          await this.incidentService.updateHeroDisposition(
            this.referralId,
            dto
          );
        } catch (e) {
          this.toastService.error('Error updating hero disposition');
        }
      }

      this.heroDispositionForm.markAsUntouched();

      Object.values(this.stateDispositionForms).forEach((form) => {
        form.markAsUntouched();
      });

      Object.values(this.localDispositionForms).forEach((form) => {
        form.markAsUntouched();
      });

      this.toastService.success('Referral updated successfully');

      this.isLoading = false;
    }
  }

  private cloneFormValues(forms: { [key: number]: FormGroup }): {
    [key: number]: any;
  } {
    return Object.keys(forms).reduce(
      (acc, key) => {
        acc[key] = forms[key].value;
        return acc;
      },
      {} as { [key: number]: any }
    );
  }

  private cloneForm(form: FormGroup): any {
    return form?.value;
  }

  private restoreFormValues(
    forms: { [key: number]: FormGroup },
    values: { [key: number]: any }
  ): void {
    Object.keys(values).forEach((key) => {
      if (forms[key]) {
        forms[key].patchValue(values[key]);
        forms[key].markAsTouched();
      }
    });
  }

  public getDispositionOptions(id: string, type: string) {
    return this[`${type}DispositionOptions`].filter(option => option.value === this[`${type}DispositionForms`][id].get('dispositionId').value);
  }

  public async multipleSelectionChange(event: MatSelectChange, type: 'local' | 'state') {
    if (event.value.length >= this[`${type}DispositionSelectedOptions`].length && event.value.length > 0) {
      const lastSelected = event.value.filter(disposition =>
        type === 'local' ? !this.localDispositionSelectedOptions.includes(disposition) : !this.stateDispositionSelectedOptions.includes(disposition)
      );
      await this.addDisposition(type, Number(lastSelected));
      this[`${type}DispositionSelectedOptions`] = [...this[`${type}DispositionSelectedOptions`], ...lastSelected];
    }
    else if (event.value.length < this[`${type}DispositionSelectedOptions`].length) {
      const lastDeselected = type === 'local' ? this.localDispositionSelectedOptions.filter(disposition => !event.value.includes(disposition))[0] :
        this.stateDispositionSelectedOptions.filter(disposition => !event.value.includes(disposition))[0];
      const lastDeselectedForm = this.Object.entries(this[`${type}DispositionForms`]).find(([key, form]) => form.get('dispositionId').value === lastDeselected);
      await this.deleteDisposition(lastDeselectedForm[0])
    }
  }

  public async addDisposition(type: 'local' | 'state', dispositionId: number) {
    this.isLoading = true;

    const prevLocalValues = this.cloneFormValues(this.localDispositionForms);
    const prevStateValues = this.cloneFormValues(this.stateDispositionForms);
    const prevReferralReview = this.cloneForm(this.referralReviewForm);
    const prevHeroDisposition = this.cloneForm(this.heroDispositionForm);

    const dto = new DispositionCreateDto({
      type,
      referralId: this.referralId,
      dispositionId
    });

    try {
      await this.incidentService.createDisposition(dto);
      const referral = await this.incidentService.getReferral(this.referralId);
      this.loadReferral(referral);

      const dispositionFormsKeys = Object.keys(this[`${type}DispositionForms`]);

      const lastDispositionForm = this[`${type}DispositionForms`][dispositionFormsKeys[dispositionFormsKeys.length - 1]];
      lastDispositionForm.patchValue({ dispositionId });
    } catch (e) {
      this.toastService.error('Error adding disposition');
    } finally {
      this.restoreFormValues(this.localDispositionForms, prevLocalValues);
      this.restoreFormValues(this.stateDispositionForms, prevStateValues);

      if (this.referralReviewForm) {
        this.referralReviewForm.patchValue(prevReferralReview);
      }

      if (this.heroDispositionForm) {
        this.heroDispositionForm.patchValue(prevHeroDisposition);
      }

      this.isLoading = false;
    }
  }

  public async deleteDisposition(id: string) {
    this.isLoading = true;

    const prevLocalValues = this.cloneFormValues(this.localDispositionForms);
    const prevStateValues = this.cloneFormValues(this.stateDispositionForms);
    const prevReferralReview = this.cloneForm(this.referralReviewForm);
    const prevHeroDisposition = this.cloneForm(this.heroDispositionForm);

    try {
      await this.incidentService.deleteDisposition(this.referralId, +id);
      const referral = await this.incidentService.getReferral(this.referralId);
      this.loadReferral(referral);
      this.toastService.success('Disposition deleted successfully');
    } catch (e) {
      this.toastService.error('Error deleting disposition');
    } finally {
      this.restoreFormValues(this.localDispositionForms, prevLocalValues);
      this.restoreFormValues(this.stateDispositionForms, prevStateValues);

      if (this.referralReviewForm) {
        this.referralReviewForm.patchValue(prevReferralReview);
      }

      if (this.heroDispositionForm) {
        this.heroDispositionForm.patchValue(prevHeroDisposition);
      }

      this.isLoading = false;
    }
  }

  public formsHaveChanges() {
    if (this.referralForm.touched || this.heroDispositionForm.touched) {
      return true;
    }
    Object.values(this.stateDispositionForms).forEach((form) => {
      if (form.touched) {
        return true;
      }
    });
    Object.values(this.localDispositionForms).forEach((form) => {
      if (form.touched) {
        return true;
      }
    });
  }

  public clickPrint(): void {
    window.print();
  }

  public onClear(control: string) {
    this.referralForm.get(control).setValue(undefined);
  }

  public onClearReview(control: string) {
    this.referralReviewForm.get(control).setValue(undefined);
  }

  protected readonly DateUtil = DateUtil;
  protected readonly Object = Object;
  protected readonly parseInt = parseInt;
}
